export const parseDurationToMs = (value: string): number => {
  if (!value) return 0;
  const trimmed = value.trim().toLowerCase();
  let total = 0;
  const hoursMatch = trimmed.match(/(\d+(\.\d+)?)\s*h/);
  const minutesMatch = trimmed.match(/(\d+)\s*m/);
  if (hoursMatch) total += parseFloat(hoursMatch[1]) * 3600000;
  if (minutesMatch) total += parseInt(minutesMatch[1]) * 60000;
  if (!hoursMatch && !minutesMatch) {
    const num = parseFloat(trimmed);
    if (!isNaN(num)) total = num * 3600000;
  }
  return total;
};

export const parseMsToString = (ms: number): string => {
  if (!ms) return '';
  const totalMinutes = Math.round(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;
  return '';
};
